module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_8019.579c3ef5.png";